import { Popover, Transition } from '@headlessui/react';
import classNames from 'classnames';
import NextImage from 'components/image/image';
import Link from 'next/link';
import { Fragment } from 'react';

import { Button } from '../../components/button/button-component';
import { Typography } from '../../components/typography/typography-component';

const MobileNavIcon = ({ open }: { open?: boolean }) => {
  return (
    <svg
      aria-hidden="true"
      className="h-3.5 w-3.5 overflow-visible stroke-slate-700"
      fill="none"
      strokeWidth={2}
      strokeLinecap="round"
    >
      <path
        d="M0 1H14M0 7H14M0 13H14"
        className={classNames(
          'origin-center transition',
          open && 'scale-90 opacity-0',
        )}
      />
      <path
        d="M2 2L12 12M12 2L2 12"
        className={classNames(
          'origin-center transition',
          !open && 'scale-90 opacity-0',
        )}
      />
    </svg>
  );
};

const MobileNavigation = () => {
  return (
    <Popover>
      <Popover.Button
        className="relative z-10 flex h-8 w-8 items-center justify-center [&:not(:focus-visible)]:focus:outline-none"
        aria-label="Toggle"
      >
        {({ open }) => <MobileNavIcon open={open} />}
      </Popover.Button>
      <Transition.Root>
        <Transition.Child
          as={Fragment}
          enter="duration-150 ease-out"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="duration-150 ease-in"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <Popover.Overlay className="fixed inset-0 bg-slate-300/50" />
        </Transition.Child>
        <Transition.Child
          as={Fragment}
          enter="duration-150 ease-out"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="duration-100 ease-in"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-95"
        >
          <Popover.Panel
            as="div"
            className="absolute inset-x-0 top-full mt-4 flex origin-top flex-col rounded-2xl bg-white p-4 px-2 text-lg tracking-tight text-slate-900 shadow-xl"
          >
            <Link target="_blank" href="https://releaselog.io/signup">
              <Button
                size="lg"
                variant="filled"
                className="mx-1 mt-4 bg-[#FF914D] font-avenir hover:bg-[#FF914D]"
              >
                Start For Free
              </Button>
            </Link>
          </Popover.Panel>
        </Transition.Child>
      </Transition.Root>
    </Popover>
  );
};

const ReleaseLogNavbar = () => {
  return (
    <header className="bg-white px-2 py-2 shadow-sm">
      <div className="mx-auto px-2 md:container sm:w-full md:px-0">
        <nav className="relative z-50 flex justify-between">
          <div className="mt-2 flex items-center md:gap-x-12">
            <div>
              <Typography
                variant="h5"
                className="font-GTWalsheimPro  text-[#4B9B9F]"
              >
                Releaselog.<span className="text-black">io</span>
              </Typography>
              <div className="flex items-center justify-end">
                <p className="text-[9px] font-bold">by</p>
                <Link href={'https://www.earlynode.com'}>
                  <NextImage
                    height={50}
                    width={50}
                    src="/assets/earlynode-logo.svg"
                    alt="Earlynode Logo"
                    className="ml-[3px] mt-[2.5px]"
                  />
                </Link>
              </div>
            </div>
          </div>
          <div className="flex items-center gap-x-10 md:gap-x-12">
            <div className="hidden flex-row items-center lg:flex">
              <Link target="_blank" href="https://releaselog.io/signup">
                <Button
                  size="lg"
                  variant="filled"
                  className="mx-1 bg-[#FF914D] font-avenir hover:bg-[#FF914D]"
                >
                  Start For Free
                </Button>
              </Link>
            </div>
            <div className="-mr-1 lg:hidden">
              <MobileNavigation />
            </div>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default ReleaseLogNavbar;
